
  import {Component, Vue} from "vue-property-decorator";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import {IApp} from "@/interfaces/app.interface";
  import {httpResource} from "@/resources/http.resource";
  import {IEventsLog} from "@/shared/EventsLog/interfaces/events-log.interface";

  @Component({
    components: {
      SimpleAppTable,
    }
  })
  export default class MovementEventsLog extends Vue {
    tableList = [];
    tableProps = [
      { prop: 'dateEvent', label: 'Дата', propType: IApp.SortingPropType.Date,  dateFormat: IApp.DateFormats.PrintedDateTimeFull},
      { prop: 'persName',  label: 'Пользователь', },
      { prop: 'eventName', label: 'Событие', },
    ];

    async mounted() {
      await this.getData();
    }

    async getData() {
      let asyncAction = async () => {
        const action = IEventsLog.Action.MainEventsLog;
        const params = {
          tableId: 1,
          recId: this.$store.state.dialog.payload.reports.reportMovementsChange.movId,
        } ;
        const {data: {result: { eventsLog } } } = await httpResource.httpAction({ action, params });
        this.tableList = eventsLog;
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }
  }
